import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PhoneForwarded, PhoneOff, Copy, Fingerprint, Share2 } from "lucide-react";
import { StatCard } from "./DashBits";
import WidgetExport from "./WidgetExport";

/** Contact Quality tab — number validity, duplicates, shared phones. */
export default function ContactQualityTab({ data }) {
  if (!data) return <div className="text-xs text-slate-400 p-4">Loading…</div>;
  const kpis = [
    { label: "Total Numbers", value: data.total_numbers, icon: PhoneForwarded, accent: "text-indigo-600" },
    { label: "Valid Numbers", value: data.valid_numbers, icon: PhoneForwarded, accent: "text-emerald-600" },
    { label: "Wrong Numbers", value: data.wrong_numbers, icon: PhoneOff, accent: "text-rose-600" },
    { label: "Unique Contacts", value: data.unique_contacts, icon: Fingerprint, accent: "text-sky-600" },
    { label: "Duplicate Numbers", value: data.duplicate_numbers, icon: Copy, accent: "text-amber-600" },
    { label: "Phones with Multiple Customer IDs", value: data.shared_phone_count, icon: Share2, accent: "text-purple-600" },
  ];
  const shared = data.shared_phones || [];
  return (
    <div className="space-y-4" data-testid="dash-tab-quality">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {kpis.map((k) => (
          <StatCard key={k.label} {...k}
                    testid={`kpi-cq-${k.label.split(" ")[0].toLowerCase()}`} />
        ))}
      </div>
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <CardTitle className="text-sm">Same Phone · Multiple Customer IDs</CardTitle>
          <WidgetExport title="Shared Phones" headers={["Phone", "Occurrences", "Customer IDs"]}
                        getRows={() => shared.map((s) => [s.phone, s.count, s.customer_ids.join("; ")])} />
        </CardHeader>
        <CardContent className="p-2" data-testid="shared-phones-table">
          {shared.length === 0 ? (
            <div className="text-xs text-slate-400 p-2">No phone number is linked to more than one Customer ID. ✅</div>
          ) : (
            <table className="w-full text-xs">
              <thead className="text-[10px] uppercase text-slate-400">
                <tr><th className="text-left px-2 py-1">Phone</th><th className="text-right px-2">Occurrences</th>
                    <th className="text-left px-2">Customer IDs</th></tr>
              </thead>
              <tbody>
                {shared.map((s) => (
                  <tr key={s.phone} className="border-t border-slate-100" data-testid={`shared-${s.phone}`}>
                    <td className="px-2 py-1.5 font-mono">{s.phone}</td>
                    <td className="text-right px-2 font-mono text-amber-700">{s.count}</td>
                    <td className="px-2">
                      <div className="flex flex-wrap gap-1">
                        {s.customer_ids.map((c) => (
                          <Badge key={c} variant="outline" className="text-[9px] font-mono">{c}</Badge>
                        ))}
                        {s.count > s.customer_ids.length && <span className="text-[9px] text-slate-400">…</span>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
